import styled from 'styled-components';
import { WARNING_TEXT } from '../../common/colors';

export const StyledLink =  styled.a`
	text-decoration: underline !important;
	color: ${WARNING_TEXT};
	font-weight: 400;
	font-size: 14px;
`;


